import { createMaterialView } from '../material-view.js';
import { NODE_ESM_SHADOW_OUTPUT } from './node-flags.js';

const NODE_ESM_SHADOW_DEPTH_CODE = `let depthMetricSM=(in.position.z+nmeShadowParams.depthValues.x)/nmeShadowParams.depthValues.y+nmeShadowParams.biasAndScale.x;let depthSM=clamp(exp(-min(87.0,nmeShadowParams.biasAndScale.z*depthMetricSM)),0.0,1.0);return vec4<f32>(depthSM,1.0,1.0,1.0);`;
function createNodeEsmShadowMaterialView(source, shadowParamsUBO) {
  const features = source._renderFeatures ?? { features: 0 };
  const view = createMaterialView(source, { features: features.features | NODE_ESM_SHADOW_OUTPUT });
  Object.defineProperty(view, "_esmShadowParamsUBO", { value: shadowParamsUBO, enumerable: false });
  Object.defineProperty(view, "_esmShadowDepthCode", { value: NODE_ESM_SHADOW_DEPTH_CODE, enumerable: false });
  return view;
}

export { createNodeEsmShadowMaterialView };
//# sourceMappingURL=esm-shadow-view.js.map
